import { connect } from 'react-redux';

import ModeratingStatusActions from './component';

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(ModeratingStatusActions);
